
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire49a6"];
var parcelRegister = parcelRequire.register;
parcelRegister("frs9M", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.getScopeId = void 0;

var $9y8DT = parcelRequire("9y8DT");

var $dDEjQ = parcelRequire("dDEjQ");

var $iNslS = parcelRequire("iNslS");

var $7c94378036b42105$var$_stringHash = $7c94378036b42105$var$_interopRequireDefault((parcelRequire("h9eEw")));

var $7c94378036b42105$var$_metrics = $7c94378036b42105$var$_interopRequireWildcard((parcelRequire("17AVh")));
function $7c94378036b42105$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $7c94378036b42105$var$_getRequireWildcardCache() {
    if (typeof WeakMap !== "function") return null;
    var cache = new WeakMap();
    $7c94378036b42105$var$_getRequireWildcardCache = function() {
        return cache;
    };
    return cache;
}
function $7c94378036b42105$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $7c94378036b42105$var$_getRequireWildcardCache();
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $7c94378036b42105$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
const $7c94378036b42105$var$CLEANUP_DELAY = 300000;
const $7c94378036b42105$var$hashStr = (str)=>String((0, $7c94378036b42105$var$_stringHash.default)(str));
const $7c94378036b42105$var$getSid = ()=>(0, $dDEjQ.getBootstrap)().getSid() || "unknown";
let $7c94378036b42105$var$cachesPolyfill;
/**
 * Returns a hashed scope identifier (org / sandbox name / etc).
 * @param {CacheScope} scope - Scope
 * @param {UserOrgContext} context - Context object.
 * @returns {string} Hashed scope ID.
 * @private
 */ const $7c94378036b42105$var$getScopeId = (scope, context)=>{
    const { imsProfile: { userId: userId }, imsOrg: imsOrg, sandbox: sandbox, subOrg: subOrg } = context;
    switch(scope){
        case $9y8DT.CacheScope.ORG:
            return $7c94378036b42105$var$hashStr(`${imsOrg}-${userId}`);
        case $9y8DT.CacheScope.SANDBOX:
            if (!sandbox) throw new Error("Sandbox not available");
            return $7c94378036b42105$var$hashStr(`${imsOrg}-${sandbox.name}-${userId}`);
        case $9y8DT.CacheScope.SUBORG:
            if (!subOrg) throw new Error("Suborg not available");
            return $7c94378036b42105$var$hashStr(`${imsOrg}-${subOrg.name}-${userId}`);
        case $9y8DT.CacheScope.USER:
        default:
            return $7c94378036b42105$var$hashStr(userId);
    }
};
module.exports.getScopeId = $7c94378036b42105$var$getScopeId;
const $7c94378036b42105$var$isExpired = (entry)=>{
    if ("expireBySession" in entry && entry.expireBySession && entry.sid !== $7c94378036b42105$var$getSid()) return true;
    return "expiresAt" in entry && entry.expiresAt < Date.now();
};

class $7c94378036b42105$var$CacheService {
    constructor(){
        $7c94378036b42105$var$_defineProperty(this, "cachePromises", {});
        $7c94378036b42105$var$_defineProperty(this, "metrics", $7c94378036b42105$var$_metrics.default.create("exc.core.services.AppCacheService"));
    }
    async cleanCache(cache) {
        // Remove expired entries.
        let removed = 0;
        try {
            const keys = await cache.keys();
            for (const request of keys){
                const response = await cache.match(request);
                if (response) {
                    const entry = await response.clone().json();
                    if ($7c94378036b42105$var$isExpired(entry)) {
                        await cache.delete(request);
                        removed++;
                    }
                }
            }
            removed && this.metrics.event("AppCache.Cleanup", {
                removed: removed
            });
        } catch (err) {
            const error = (0, $iNslS.getErrorMessage)(err);
            this.metrics.event("AppCache.CleanupFailed", {
                error: error,
                removed: removed
            }, {
                level: $7c94378036b42105$var$_metrics.Level.ERROR
            });
        }
    }
    /**
   * Opens the named cache.
   * @param {string} name
   * @returns Cache - Named Cache object.
   * @private
   */ async openCache(name) {
        if (!this.cachePromises[name]) {
            if (!window.caches) {
                // No cache storage. Likely old browser or under test.
                // Use a memory based polyfill.
                if (!$7c94378036b42105$var$cachesPolyfill) $7c94378036b42105$var$cachesPolyfill = (await Promise.resolve().then(function() {
                    return (parcelRequire("lBUGj"));
                }).then((res)=>$7c94378036b42105$var$_interopRequireWildcard(res))).default;
                return $7c94378036b42105$var$cachesPolyfill.open(name);
            }
            this.cachePromises[name] = caches.open(name).then((cache)=>{
                setTimeout(()=>this.cleanCache(cache), $7c94378036b42105$var$CLEANUP_DELAY);
                return cache;
            });
        }
        return this.cachePromises[name];
    }
    /**
   * Gets the cache path (Relative URL) for the cached key.
   * @param {string} key - Cache Entry Key
   * @param {string} appId - Current Application ID
   * @param {UserOrgContext} context - Context ojbect
   * @param {CacheScope} scope - Cache Scope
   * @returns {string} cache path.
   * @private
   */ getCacheEntryPath(key, appId, context, scope = $9y8DT.CacheScope.DEFAULT) {
        const scopeId = $7c94378036b42105$var$getScopeId(scope, context);
        return `/appCache/${appId}/${scope}/${scopeId}/${encodeURIComponent(key)}`;
    }
    /**
   * Deletes the cached entry (If exists).
   * @param {string} key - Cache Entry Key
   * @param {string} appId - Current Application ID
   * @param {UserOrgContext} context - Context ojbect
   * @param {CacheScope} scope - Cache Scope
   */ async delete({ appId: appId, key: key, context: context, scope: scope }) {
        try {
            const path = this.getCacheEntryPath(key, appId, context, scope);
            const cache = await this.openCache(`${appId}Cache`);
            await cache.delete(path);
        } catch (err) {
            const error = (0, $iNslS.getErrorMessage)(err);
            this.metrics.event("AppCache.DeleteFailed", {
                appId: appId,
                error: error,
                key: key
            }, {
                level: $7c94378036b42105$var$_metrics.Level.ERROR
            });
        }
    }
    /**
   * Returns a cached entry if availble.
   * @template T
   * @param {string} key - Cache Entry Key
   * @param {string} appId - Current Application ID
   * @param {UserOrgContext} context - Context ojbect
   * @param {CacheScope} scope - Cache Scope
   *
   * @returns {CacheEntry|undefined}
   */ async get({ appId: appId, key: key, context: context, scope: scope }) {
        try {
            const path = this.getCacheEntryPath(key, appId, context, scope);
            const cache = await this.openCache(`${appId}Cache`);
            const request = await cache.match(path);
            if (request) {
                const entry = await request.clone().json();
                if (!$7c94378036b42105$var$isExpired(entry)) return entry;
                await cache.delete(path);
            }
        } catch (err) {
            const error = (0, $iNslS.getErrorMessage)(err);
            this.metrics.event("AppCache.GetFailed", {
                appId: appId,
                error: error,
                key: key
            }, {
                level: $7c94378036b42105$var$_metrics.Level.ERROR
            });
        }
    }
    /**
   * Stores a value in the cache.
   * @template T
   * @param {CacheExpiry} expiry
   * @param {string} key - Cache Entry Key
   * @param {string} appId - Current Application ID
   * @param {UserOrgContext} context - Context ojbect
   * @param {T} value - Value to cache
   * @param {CacheScope} scope - Cache Scope
   */ async set({ appId: appId, expiry: expiry, key: key, context: context, value: value, scope: scope }) {
        try {
            const cacheExpiry = expiry || $9y8DT.CacheTTL.DEFAULT;
            const path = this.getCacheEntryPath(key, appId, context, scope);
            const cache = await this.openCache(`${appId}Cache`);
            const createdAt = Date.now();
            const baseEntry = {
                createdAt: createdAt,
                key: key,
                value: value
            };
            const entry = cacheExpiry === $9y8DT.CacheTTL.IMS_SESSION ? {
                ...baseEntry,
                expireBySession: true,
                sid: $7c94378036b42105$var$getSid()
            } : {
                ...baseEntry,
                expiresAt: createdAt + cacheExpiry * 1000
            };
            await cache.put(path, new Response(JSON.stringify(entry), {
                headers: {
                    "content-type": "Application/json"
                }
            }));
            return entry;
        } catch (err) {
            const error = (0, $iNslS.getErrorMessage)(err);
            this.metrics.event("AppCache.SetFailed", {
                appId: appId,
                error: error,
                key: key
            }, {
                level: $7c94378036b42105$var$_metrics.Level.ERROR
            });
        }
    }
}
const $7c94378036b42105$var$cacheService = new $7c94378036b42105$var$CacheService();
var $7c94378036b42105$var$_default = $7c94378036b42105$var$cacheService;
module.exports.default = $7c94378036b42105$var$_default;

});
parcelRegister("9y8DT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.CacheTTL = module.exports.CacheScope = void 0;

var $ihFuI = parcelRequire("ihFuI");
/*************************************************************************
 * Copyright 2022 Adobe
 * All Rights Reserved.
 *
 * NOTICE: Adobe permits you to use, modify, and distribute this file in
 * accordance with the terms of the Adobe license agreement accompanying
 * it. If you have received this file from a source other than Adobe,
 * then your use, modification, or distribution of it requires the prior
 * written permission of Adobe.
 **************************************************************************/ /**
 * APIs for managing a client side persisted cache.
 * Unified Shell will store the data against its own domain, which allows data caching
 * even when the actual app runs on a domain which is 3rd party to Unified Shell's.
 *
 * For example, the API will work in Chrome incognito when Unified Shell runs on an adobe.com domain
 * and the embedded applications run on the adobe.net domain.
 *
 * These APIs utilizes the [Browser Cache API](https://developer.mozilla.org/en-US/docs/Web/API/Cache) under the hood and are all run asynchronously.
 *
 * If migrating from Local Storage to Cache API, make sure all the app logic is async first.
 *
 * NOTE: This API should not be used to cache any PII data to comply with Adobe privacy policies.
 *
 * To consume this API, add the following import to your code.
 *
 * ```typescript
 * import cache from '@adobe/exc-app/cache';
 * ```
 *
 * The default export is an object of type [CacheAPI](../interfaces/_cache_.cacheapi.md)
 *
 * API reference: [scroll down](#index)
 *
 * ### Sample code
 *
 * ```typescript
 * import cache, {CacheTTL, CacheScope} from '@adobe/exc-app/cache';
 *
 * // By default, cached data is tied to the user and cached for a week.
 * await cache.set<MyType>({key: 'some-cache-key', value: myTypeInstance});
 *
 * // Both scope and expiry can be adjusted.
 * await cache.set<MyType>({key: 'some-cache-key', value: myTypeInstance, expiry: CacheTTL.DAY, scope: CacheScope.ORG});
 *
 * // It is also possible to bind cache data to the current IMS session, it will expire when the user logs out.
 * await cache.set<MyType>({key: 'some-cache-key', value: myTypeInstance, expiry: CacheTTL.IMS_SESSION});
 *
 * // Cache get
 * const myData: MyType = await cache.get<MyType>({key: 'some-cache-key'});
 *
 * // Get scope must be identical to the scope used for set - Always use the same scope for both.
 * const myData2: MyType = await cache.get<MyType>({key: 'some-cache-key', scope: CacheScope.ORG});
 *
 * // Cache delete.
 * await cache.delete({key: 'some-cache-key'});
 * ```
 * @packageDocumentation
 * @module cache
 */ /**
 * @ignore
 */ let $3f8551e4f9ba43e2$var$CacheScope;
/**
 * @ignore
 */ module.exports.CacheScope = $3f8551e4f9ba43e2$var$CacheScope;
(function(CacheScope) {
    CacheScope["DEFAULT"] = "user";
    CacheScope["ORG"] = "org";
    CacheScope["SANDBOX"] = "sandbox";
    CacheScope["SUBORG"] = "suborg";
    CacheScope["USER"] = "user";
})($3f8551e4f9ba43e2$var$CacheScope || (module.exports.CacheScope = $3f8551e4f9ba43e2$var$CacheScope = {}));
let $3f8551e4f9ba43e2$var$CacheTTL;
module.exports.CacheTTL = $3f8551e4f9ba43e2$var$CacheTTL;
(function(CacheTTL) {
    CacheTTL[CacheTTL["DONT_CACHE"] = 0] = "DONT_CACHE";
    CacheTTL[CacheTTL["IMS_SESSION"] = -1] = "IMS_SESSION";
    CacheTTL[CacheTTL["DEFAULT"] = 604800] = "DEFAULT";
    CacheTTL[CacheTTL["HOUR"] = 3600] = "HOUR";
    CacheTTL[CacheTTL["DAY"] = 86400] = "DAY";
    CacheTTL[CacheTTL["WEEK"] = 604800] = "WEEK";
    CacheTTL[CacheTTL["MONTH"] = 2592000] = "MONTH";
})($3f8551e4f9ba43e2$var$CacheTTL || (module.exports.CacheTTL = $3f8551e4f9ba43e2$var$CacheTTL = {}));
const $3f8551e4f9ba43e2$var$cache = {
    delete: (params)=>(0, $ihFuI.getImpl)("cache")().delete(params),
    get: (params)=>(0, $ihFuI.getImpl)("cache")().get(params),
    set: (params)=>(0, $ihFuI.getImpl)("cache")().set(params)
};
var $3f8551e4f9ba43e2$var$_default = $3f8551e4f9ba43e2$var$cache;
module.exports.default = $3f8551e4f9ba43e2$var$_default;

});

parcelRegister("lBUGj", function(module, exports) {

var $Ha5sG = parcelRequire("Ha5sG");
module.exports = $Ha5sG("4CIDK").then(()=>parcelRequire("44EFY"));

});
parcelRegister("Ha5sG", function(module, exports) {
"use strict";

function $081bd75a75e47148$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("3cmwu")).resolve(id));
}
module.exports = $081bd75a75e47148$var$load;

});
parcelRegister("3cmwu", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $2543f6b5f5c59170$export$6503ec6e8aabbaf; }, function (v) { return $2543f6b5f5c59170$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $2543f6b5f5c59170$export$f7ad0328861e2f03; }, function (v) { return $2543f6b5f5c59170$export$f7ad0328861e2f03 = v; });
var $2543f6b5f5c59170$export$6503ec6e8aabbaf;
var $2543f6b5f5c59170$export$f7ad0328861e2f03;
"use strict";
var $2543f6b5f5c59170$var$mapping = new Map();
function $2543f6b5f5c59170$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$2543f6b5f5c59170$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $2543f6b5f5c59170$var$resolve(id) {
    var resolved = $2543f6b5f5c59170$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$2543f6b5f5c59170$export$6503ec6e8aabbaf = $2543f6b5f5c59170$var$register;
$2543f6b5f5c59170$export$f7ad0328861e2f03 = $2543f6b5f5c59170$var$resolve;

});




parcelRegister("fOiXv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.DataPrefetchService = module.exports.SHARED_APP_ID = void 0;

var $ea38649f11fffa85$var$_dataPrefetchContracts = $ea38649f11fffa85$var$_interopRequireDefault((parcelRequire("9vjvm")));

var $ea38649f11fffa85$var$_CacheService = $ea38649f11fffa85$var$_interopRequireWildcard((parcelRequire("frs9M")));

var $9y8DT = parcelRequire("9y8DT");

var $ea38649f11fffa85$var$_emitter = $ea38649f11fffa85$var$_interopRequireDefault((parcelRequire("dJSrf")));

var $4ua75 = parcelRequire("4ua75");

var $iNslS = parcelRequire("iNslS");

var $apIgy = parcelRequire("apIgy");

var $ea38649f11fffa85$var$_stringHash = $ea38649f11fffa85$var$_interopRequireDefault((parcelRequire("h9eEw")));

var $khMmQ = parcelRequire("khMmQ");

var $ea38649f11fffa85$var$_metrics = $ea38649f11fffa85$var$_interopRequireWildcard((parcelRequire("17AVh")));

var $3Zpnv = parcelRequire("3Zpnv");
function $ea38649f11fffa85$var$_getRequireWildcardCache() {
    if (typeof WeakMap !== "function") return null;
    var cache = new WeakMap();
    $ea38649f11fffa85$var$_getRequireWildcardCache = function() {
        return cache;
    };
    return cache;
}
function $ea38649f11fffa85$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $ea38649f11fffa85$var$_getRequireWildcardCache();
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $ea38649f11fffa85$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $ea38649f11fffa85$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
const $ea38649f11fffa85$var$SHARED_APP_ID = "sharedData";
module.exports.SHARED_APP_ID = $ea38649f11fffa85$var$SHARED_APP_ID;
const $ea38649f11fffa85$var$getVersionedKey = (key, contract)=>{
    const hash = (0, $ea38649f11fffa85$var$_stringHash.default)(contract.gql ? `${contract.gql.query}-${JSON.stringify(contract.gql.variables || {})}` : "");
    return `${hash}/${key}`;
};
class $ea38649f11fffa85$var$DataPrefetchService extends $ea38649f11fffa85$var$_emitter.default {
    constructor(){
        super();
        $ea38649f11fffa85$var$_defineProperty(this, "promises", {});
        $ea38649f11fffa85$var$_defineProperty(this, "metrics", $ea38649f11fffa85$var$_metrics.default.create("exc.core.services.DataPrefetchService"));
        $ea38649f11fffa85$var$_defineProperty(this, "contracts", {});
        $ea38649f11fffa85$var$_dataPrefetchContracts.default.forEach((contract)=>this.contracts[contract.key] = contract);
    }
    /**
   * Executes a graphql query based on a data contract.
   * @template T
   * @param gql - GraphQL Data definition
   * @param context - Core Context
   * @param defaultValue - Default value to return if needed.
   * @param cached - Cached Data (If available)
   * @param contract - Contract to fulfill
   * @returns [T, boolean] - Array containing the query result and default flag
   * (True if default, false if actual data)
   * @private
   */ async executeGraphQLQuery(gql, context, defaultValue, appId, cached, contract) {
        const { dataPath: dataPath, fetchScope: scope, variables: origVariables, query: query } = gql;
        const variables = (0, $khMmQ.transformVariables)(origVariables, context, appId, cached, contract);
        if (scope === $4ua75.FetchScope.SANDBOX && !context.sandbox?.name) // There is no selected sandbox, return default and do not cache.
        return [
            defaultValue,
            true
        ];
        let response;
        if (dataPath) {
            const gqlResponse = await (0, $apIgy.gqlQuery)(query, variables, {
                scope: scope
            });
            response = gqlResponse?.[dataPath];
        } else response = await (0, $apIgy.gqlQuery)(query, variables, {
            scope: scope
        });
        return response ? [
            response,
            false
        ] : [
            defaultValue,
            true
        ];
    }
    /**
   * Retains original values from the initial, cached query response.
   * @template T
   * @param newValue - New data response
   * @param cachedValue - Cached data response
   * @param dedup - Deduplication config
   * @param keepOriginal - Elements to retain
   * @returns merged value
   * @private
   */ mergedWithCachedValue(newValue, cachedValue, dedup, keepOriginal) {
        let value = newValue;
        if (dedup) value = (0, $khMmQ.mergeValuesByUniqueId)(value, cachedValue, dedup);
        if (keepOriginal?.length) keepOriginal.forEach((element)=>{
            if (element in cachedValue) value = {
                ...value,
                [element]: cachedValue[element]
            };
        });
        return value;
    }
    /**
   * Executes a GraphQL query and cache the result if not default.
   * @template T
   * @param contract - Data contract
   * @param key - Cached item key
   * @param context - Core Context
   * @param appId - Requesting application ID
   * @param cached - Cached Data (If available)
   * @returns Query result + Cache information
   * @private
   */ async executeAndCache(contract, key, context, appId, cached) {
        const { defaultValue: defaultValue, expiry: expiry, gql: gql, refreshData: refreshData, scope: scope } = contract;
        const now = Date.now();
        let query = gql;
        if (cached?.value && refreshData?.gql) // To optimize our query performance, we can use the query needed for refresh
        // and then merge it with the cached data we already have.
        query = refreshData.gql;
        const [queryValue, isDefault] = await this.executeGraphQLQuery(query, context, defaultValue, appId, cached, contract);
        let value = queryValue;
        if (cached?.value && refreshData?.gql && !isDefault) {
            // Use the deduplicate config to merge cached and fresh data.
            // Note currently without dedup, only the fresh data will be used.
            const { dedup: dedup, keepOriginal: keepOriginal } = refreshData;
            value = this.mergedWithCachedValue(queryValue, cached.value, dedup, keepOriginal);
        }
        this.emit("prefetch", {
            key: contract.key,
            scopeId: (0, $ea38649f11fffa85$var$_CacheService.getScopeId)(scope, context),
            value: value
        });
        if (expiry !== $9y8DT.CacheTTL.DONT_CACHE && !isDefault) try {
            const entry = await $ea38649f11fffa85$var$_CacheService.default.set({
                appId: appId,
                context: context,
                expiry: expiry,
                key: key,
                scope: scope,
                value: value
            });
            if (entry) return entry;
        } catch (err) {
            const error = (0, $iNslS.getErrorMessage)(err);
            this.metrics.event("Prefetch.cacheSetFailed", {
                error: error
            }, {
                level: $ea38649f11fffa85$var$_metrics.Level.ERROR
            });
        }
        return {
            createdAt: now,
            expiresAt: now,
            key: key,
            value: value
        };
    }
    /**
   * Fetches fresh data from the network to fullfil the data contract.
   * @template T
   * @param contract - Data contract
   * @param key - Cached item key
   * @param context - Core Context
   * @param appId - Requesting application ID
   * @param cached - Cached Data (If available)
   * @returns Query result + Cache information
   * @private
   */ async getFreshData(contract, key, context, appId, cached) {
        const { defaultValue: defaultValue, fetchWhen: fetchWhen } = contract;
        const { imsOrg: imsOrg, imsProfile: imsProfile } = context;
        const now = Date.now();
        if (fetchWhen) {
            // Check if we should prefetch at this point.
            const { serviceCodes: serviceCodes } = fetchWhen;
            if (serviceCodes && !(0, $3Zpnv.orgHasServiceCode)(imsOrg, imsProfile, serviceCodes)) // The profile does not have the required service code.
            // Return the default value and do not cache.
            return {
                createdAt: now,
                expiresAt: now,
                key: key,
                value: defaultValue
            };
        }
        const promiseKey = `gql:query:${key}`;
        let promise = this.promises[promiseKey];
        if (!promise) {
            if (!contract.gql) // Currently only GraphQL is supported for data prefetching.
            throw new Error("Only GraphQL prefetching currently supported");
            promise = this.executeAndCache(contract, key, context, appId, cached);
            promise.finally(()=>delete this.promises[promiseKey]);
            this.promises[promiseKey] = promise;
        }
        return promise;
    }
    /**
   * Creates a new Data promise for the given contract.
   * @template T
   * @param {DataPrefetchContract} contract - Data contract
   * @param {UserOrgContext} context - Core Context
   * @param {string} appId - Requesting application ID
   * @param options - Prefetch options
   * @returns {CacheEntry<T>} - Query result + Cache information
   * @private
   */ async getDataPromise(contract, context, appId, options) {
        const { expiry: expiry, key: key, revalidate: { enabled: revalidateEnabled, revalidateAfterSec: revalidateAfterSec = 0, immediate: immediate } = {}, scope: scope } = contract;
        const versionedKey = $ea38649f11fffa85$var$getVersionedKey(key, contract);
        const { createdAfter: createdAfter = 0 } = options || {};
        let entry;
        if (expiry !== $9y8DT.CacheTTL.DONT_CACHE) {
            entry = await $ea38649f11fffa85$var$_CacheService.default.get({
                appId: appId,
                context: context,
                key: versionedKey,
                scope: scope
            });
            if (entry && entry.createdAt > createdAfter) {
                // Data is cached. See if we need to fetch still.
                if (revalidateEnabled && Date.now() - entry.createdAt >= revalidateAfterSec * 1000) (0, $3Zpnv.runInBackground)(!(immediate || options?.revalidateImmediately)).then(()=>this.getFreshData(contract, versionedKey, context, appId, entry));
                return entry;
            }
        }
        return this.getFreshData(contract, versionedKey, context, appId, entry);
    }
    /**
   * Checks context data to see if a contract can be fulfilled.
   * @param {string} key - Contract key
   * @param {UserOrgContext} context - Core Context
   * @returns {boolean} False if context has all data needed, true otherwise.
   */ isContextMissing(key, context) {
        const contract = this.contracts[key];
        let contextMissing = !context.imsOrg;
        if (contract) contextMissing = contextMissing || (contract.scope === $9y8DT.CacheScope.SANDBOX || contract.gql?.fetchScope === $4ua75.FetchScope.SANDBOX) && !context.sandbox?.name || contract.scope === $9y8DT.CacheScope.SUBORG && !context.subOrg;
        return contextMissing;
    }
    /**
   * Returns data prefetched for contract.
   * @template T
   * @param {string} key - Contract key
   * @param {UserOrgContext} context - Core Context
   * @param {string} dataAppId - Requesting application ID
   * @param options - Prefetch options
   * @returns {CacheEntry<T>} - Data + Cache information
   */ async getData(key, context, dataAppId = "", options) {
        const contract = this.contracts[key];
        if (!contract) throw new Error(`Unknown data contract - ${key}`);
        const appId = contract.shared || !dataAppId ? $ea38649f11fffa85$var$SHARED_APP_ID : dataAppId;
        const promiseKey = `${(0, $ea38649f11fffa85$var$_CacheService.getScopeId)(contract.scope, context)}`;
        let promise = this.promises[promiseKey];
        if (!promise) {
            promise = this.getDataPromise(contract, context, appId, options);
            promise.catch((err)=>{
                const error = (0, $iNslS.getErrorMessage)(err);
                this.metrics.event("Prefetch.Failed", {
                    error: error,
                    key: key
                }, {
                    level: $ea38649f11fffa85$var$_metrics.Level.ERROR
                });
            }).finally(()=>delete this.promises[promiseKey]);
            this.promises[promiseKey] = promise;
        }
        return promise;
    }
    /**
   * Updates data cached for contract.
   * @template T
   * @param {string} key - Contract key
   * @param {UserOrgContext} context - Core Context
   * @param {T} value - Data to be cached
   * @param {string} dataAppId - Requesting application ID
   * @returns {Promise<CacheEntry<any> | undefined>} The new cache entry if successful, otherwise undefined
   */ updateCache(key, context, value, dataAppId = "") {
        const contract = this.contracts[key];
        if (!contract) {
            this.metrics.warn(`Prefetch.UpdateFailed - Unknown data contract ${key}`);
            return Promise.resolve(undefined);
        }
        const appId = contract.shared || !dataAppId ? $ea38649f11fffa85$var$SHARED_APP_ID : dataAppId;
        const versionedKey = $ea38649f11fffa85$var$getVersionedKey(key, contract);
        return $ea38649f11fffa85$var$_CacheService.default.set({
            appId: appId,
            context: context,
            key: versionedKey,
            scope: contract.scope,
            value: value
        });
    }
}
module.exports.DataPrefetchService = $ea38649f11fffa85$var$DataPrefetchService;
const $ea38649f11fffa85$var$dataPrefetchService = new $ea38649f11fffa85$var$DataPrefetchService();
var $ea38649f11fffa85$var$_default = $ea38649f11fffa85$var$dataPrefetchService;
module.exports.default = $ea38649f11fffa85$var$_default;

});
parcelRegister("9vjvm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fNqcA = parcelRequire("fNqcA");

var $4z2Gh = parcelRequire("4z2Gh");

var $h7qst = parcelRequire("h7qst");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ var $40f0e28eefaef22c$var$_default = [
    $fNqcA.dashboardBySandboxContract,
    $fNqcA.dashboardContract,
    $4z2Gh.recentsBySandboxContract,
    $4z2Gh.recentsContract,
    $h7qst.userRolesContract
];
module.exports.default = $40f0e28eefaef22c$var$_default;

});
parcelRegister("fNqcA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.dashboardBySandboxContract = module.exports.dashboardContract = module.exports.DASHBOARD_SANDBOX_PREFETCH_KEY = module.exports.DASHBOARD_PREFETCH_KEY = void 0;

var $9y8DT = parcelRequire("9y8DT");

var $4ua75 = parcelRequire("4ua75");

var $gEbfo = parcelRequire("gEbfo");

var $9OFRo = parcelRequire("9OFRo");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ const $f144d8004df97a77$var$DASHBOARD_PREFETCH_KEY = "dashboard-org";
module.exports.DASHBOARD_PREFETCH_KEY = $f144d8004df97a77$var$DASHBOARD_PREFETCH_KEY;
const $f144d8004df97a77$var$DASHBOARD_SANDBOX_PREFETCH_KEY = "dashboard-sandbox";
module.exports.DASHBOARD_SANDBOX_PREFETCH_KEY = $f144d8004df97a77$var$DASHBOARD_SANDBOX_PREFETCH_KEY;
const $f144d8004df97a77$var$gqlDef = {
    dataPath: "getSettings",
    fetchScope: $4ua75.FetchScope.ORG,
    query: $9OFRo.SETTINGS_QUERY,
    variables: {
        appId: "${appId}",
        groupId: "exc-pueblo",
        level: $gEbfo.SettingsLevel.USERORG,
        settings: {
            dashboard: null
        }
    }
};
const $f144d8004df97a77$var$dashboardContract = {
    defaultValue: {
        settings: {
            dashboard: null
        }
    },
    expiry: $9y8DT.CacheTTL.MONTH,
    gql: $f144d8004df97a77$var$gqlDef,
    isSensitive: false,
    key: $f144d8004df97a77$var$DASHBOARD_PREFETCH_KEY,
    refreshData: {
        gql: $f144d8004df97a77$var$gqlDef
    },
    revalidate: {
        enabled: false
    },
    scope: $9y8DT.CacheScope.ORG,
    shared: false
};
module.exports.dashboardContract = $f144d8004df97a77$var$dashboardContract;
const $f144d8004df97a77$var$gqlDefWithSandbox = {
    ...$f144d8004df97a77$var$gqlDef,
    fetchScope: $4ua75.FetchScope.SANDBOX
};
const $f144d8004df97a77$var$dashboardBySandboxContract = {
    defaultValue: {
        settings: {
            dashboard: null
        }
    },
    expiry: $9y8DT.CacheTTL.MONTH,
    gql: $f144d8004df97a77$var$gqlDefWithSandbox,
    isSensitive: false,
    key: $f144d8004df97a77$var$DASHBOARD_SANDBOX_PREFETCH_KEY,
    refreshData: {
        gql: $f144d8004df97a77$var$gqlDefWithSandbox
    },
    revalidate: {
        enabled: false
    },
    scope: $9y8DT.CacheScope.SANDBOX,
    shared: false
};
module.exports.dashboardBySandboxContract = $f144d8004df97a77$var$dashboardBySandboxContract;

});
parcelRegister("9OFRo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getSettings = module.exports.SETTINGS_QUERY = void 0;

var $apIgy = parcelRequire("apIgy");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2023 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ const $cc12db92ed931491$var$SETTINGS_QUERY = `
  query settingsQuery($appId: String!, $groupId: String!, $level: String!, $settings: JSON!) {
    getSettings(appId: $appId, groupId: $groupId, level: $level, settings: $settings) {
      settings
    }
  }
`;
module.exports.SETTINGS_QUERY = $cc12db92ed931491$var$SETTINGS_QUERY;
const $cc12db92ed931491$var$getSettings = (options)=>(0, $apIgy.gqlQuery)($cc12db92ed931491$var$SETTINGS_QUERY, options);
module.exports.getSettings = $cc12db92ed931491$var$getSettings;

});


parcelRegister("4z2Gh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.recentsBySandboxContract = module.exports.recentsContract = module.exports.RECENTS_SANDBOX_PREFETCH_KEY = module.exports.RECENTS_PREFETCH_KEY = module.exports.DEFAULT_PAGE_SIZE = void 0;

var $9y8DT = parcelRequire("9y8DT");

var $4ua75 = parcelRequire("4ua75");

var $ldKJa = parcelRequire("ldKJa");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ // This contract will eventually live in @exc/pueblo and will be consumed through a manifest.
// Currently placing it here.
const $3941006da6ca8e20$var$DEFAULT_PAGE_SIZE = 20;
module.exports.DEFAULT_PAGE_SIZE = $3941006da6ca8e20$var$DEFAULT_PAGE_SIZE;
const $3941006da6ca8e20$var$RECENTS_PREFETCH_KEY = "recents-org";
module.exports.RECENTS_PREFETCH_KEY = $3941006da6ca8e20$var$RECENTS_PREFETCH_KEY;
const $3941006da6ca8e20$var$RECENTS_SANDBOX_PREFETCH_KEY = "recents-sandbox";
module.exports.RECENTS_SANDBOX_PREFETCH_KEY = $3941006da6ca8e20$var$RECENTS_SANDBOX_PREFETCH_KEY;
const $3941006da6ca8e20$var$RECENTS_VARIABLES = {
    acrossSandbox: true,
    pageSize: $3941006da6ca8e20$var$DEFAULT_PAGE_SIZE
}; // Recents (Org level) Data Contract
const $3941006da6ca8e20$var$recentsContract = {
    defaultValue: {
        cursor: null,
        recents: []
    },
    expiry: $9y8DT.CacheTTL.DAY,
    gql: {
        dataPath: "recent",
        fetchScope: $4ua75.FetchScope.ORG,
        query: $ldKJa.RECENTS_QUERY,
        variables: $3941006da6ca8e20$var$RECENTS_VARIABLES
    },
    isSensitive: false,
    key: $3941006da6ca8e20$var$RECENTS_PREFETCH_KEY,
    refreshData: {
        dedup: {
            arrayElement: "recents",
            arrayLimit: 1000,
            keyField: "objId",
            sortAscending: false,
            sortField: "clickTimestamp"
        },
        gql: {
            dataPath: "recent",
            fetchScope: $4ua75.FetchScope.ORG,
            query: $ldKJa.RECENTS_QUERY,
            variables: {
                ...$3941006da6ca8e20$var$RECENTS_VARIABLES,
                tillTimeStamp: "${dedup.sortField}"
            }
        },
        keepOriginal: [
            "cursor"
        ]
    },
    revalidate: {
        enabled: true,
        revalidateAfterSec: 30
    },
    scope: $9y8DT.CacheScope.ORG,
    shared: true
}; // Recents (Sandbox level) Data Contract
module.exports.recentsContract = $3941006da6ca8e20$var$recentsContract;
const $3941006da6ca8e20$var$recentsBySandboxContract = {
    defaultValue: {
        cursor: null,
        recents: []
    },
    expiry: $9y8DT.CacheTTL.DAY,
    gql: {
        dataPath: "recent",
        fetchScope: $4ua75.FetchScope.SANDBOX,
        query: $ldKJa.RECENTS_QUERY,
        variables: {
            ...$3941006da6ca8e20$var$RECENTS_VARIABLES,
            acrossSandbox: false
        }
    },
    isSensitive: false,
    key: $3941006da6ca8e20$var$RECENTS_SANDBOX_PREFETCH_KEY,
    refreshData: {
        dedup: {
            arrayElement: "recents",
            arrayLimit: 1000,
            keyField: "objId",
            sortAscending: false,
            sortField: "clickTimestamp"
        },
        gql: {
            dataPath: "recent",
            fetchScope: $4ua75.FetchScope.SANDBOX,
            query: $ldKJa.RECENTS_QUERY,
            variables: {
                ...$3941006da6ca8e20$var$RECENTS_VARIABLES,
                acrossSandbox: false,
                tillTimeStamp: "${dedup.sortField}"
            }
        },
        keepOriginal: [
            "cursor"
        ]
    },
    revalidate: {
        enabled: true,
        revalidateAfterSec: 30
    },
    scope: $9y8DT.CacheScope.SANDBOX,
    shared: true
};
module.exports.recentsBySandboxContract = $3941006da6ca8e20$var$recentsBySandboxContract;

});
parcelRegister("ldKJa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getRecents = module.exports.RECENTS_QUERY = void 0;

var $apIgy = parcelRequire("apIgy");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ const $af46be79b6b1d73c$var$RECENTS_QUERY = `
  query recentQuery ($pageSize: Int, $service: String, $objType: String, $cursor: String, $acrossSandbox: Boolean, $tillTimeStamp: Float){
    recent (pageSize: $pageSize, service: $service, objType: $objType, cursor: $cursor, acrossSandbox: $acrossSandbox, tillTimeStamp: $tillTimeStamp){
      recents {
        objId
        objName
        objType
        entityCode
        description
        objIcon
        serviceId
        redirectUrl
        clickTimestamp
        viewLink
        editLink
        status
        color
        createdBy
        lastModifiedBy
        modifiedOn
        sandboxName
        accessHistory
      }
      cursor
    }
  }
`;
module.exports.RECENTS_QUERY = $af46be79b6b1d73c$var$RECENTS_QUERY;
const $af46be79b6b1d73c$var$getRecents = (vars)=>(0, $apIgy.gqlQuery)($af46be79b6b1d73c$var$RECENTS_QUERY, vars);
module.exports.getRecents = $af46be79b6b1d73c$var$getRecents;

});


parcelRegister("h7qst", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.userRolesContract = module.exports.USER_ROLES_PREFETCH_KEY = void 0;

var $9y8DT = parcelRequire("9y8DT");

var $4ua75 = parcelRequire("4ua75");

var $gEbfo = parcelRequire("gEbfo");

var $9OFRo = parcelRequire("9OFRo");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2023 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ const $c4f7d345a6306f77$var$USER_ROLES_PREFETCH_KEY = "user-roles";
module.exports.USER_ROLES_PREFETCH_KEY = $c4f7d345a6306f77$var$USER_ROLES_PREFETCH_KEY;
const $c4f7d345a6306f77$var$gqlDef = {
    dataPath: "getSettings",
    fetchScope: $4ua75.FetchScope.ORG,
    query: $9OFRo.SETTINGS_QUERY,
    variables: {
        appId: "userPreferences",
        groupId: "exc-preferences",
        level: $gEbfo.SettingsLevel.USER,
        settings: {
            userRoles: null
        }
    }
};
const $c4f7d345a6306f77$var$userRolesContract = {
    defaultValue: {
        settings: {
            userRoles: {
                roles: []
            }
        }
    },
    expiry: $9y8DT.CacheTTL.MONTH,
    gql: $c4f7d345a6306f77$var$gqlDef,
    isSensitive: false,
    key: $c4f7d345a6306f77$var$USER_ROLES_PREFETCH_KEY,
    refreshData: {
        gql: $c4f7d345a6306f77$var$gqlDef
    },
    revalidate: {
        enabled: false
    },
    scope: $9y8DT.CacheScope.USER,
    shared: true
};
module.exports.userRolesContract = $c4f7d345a6306f77$var$userRolesContract;

});


parcelRegister("khMmQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.mergeValuesByUniqueId = $0c509505748f8fd4$var$mergeValuesByUniqueId;
module.exports.transformVariables = $0c509505748f8fd4$var$transformVariables;

var $lKKKr = parcelRequire("lKKKr");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ /**
 * Returns the ACP fullfilable data record. This is used to allow the sandbox switcher to run on QA
 * against stage orgs.
 * @param environment
 * @param imsOrg - IMS Org ID
 * @param projectedProductContext - ACP Product Context
 * @returns Fulfillable data record if available and needed.
 */ const $0c509505748f8fd4$var$getAcpFulfillableData = ({ environment: environment, imsOrg: imsOrg, imsProfile: { projectedProductContext: projectedProductContext } })=>{
    let result = undefined;
    if (environment === "dev" || environment === "qa") {
        const { prodCtx: acpPC } = projectedProductContext.find(({ prodCtx: prodCtx })=>prodCtx.serviceCode === "acp" && prodCtx.owningEntity === imsOrg && prodCtx.fulfillable_data) || {};
        if (acpPC) result = JSON.parse(acpPC.fulfillable_data);
    }
    return result;
};
const $0c509505748f8fd4$var$getArray = (data, arrayElement)=>{
    const array = data[arrayElement];
    if (array && Array.isArray(array)) return array;
    return [];
};
function $0c509505748f8fd4$var$mergeValuesByUniqueId(fresh, cached, dedup) {
    const { arrayElement: arrayElement, keyField: keyField, sortAscending: sortAscending, sortField: sortField } = dedup;
    const keys = new Set();
    let newArr = [];
    for (const element of [
        ...$0c509505748f8fd4$var$getArray(fresh, arrayElement),
        ...$0c509505748f8fd4$var$getArray(cached, arrayElement)
    ]){
        const key = element[keyField];
        if (!keys.has(key)) {
            newArr.push(element);
            keys.add(key);
        }
    }
    const cmp = (a, b)=>{
        if (typeof a === "string" && typeof b === "string") return sortAscending ? a.localeCompare(b) : b.localeCompare(a);
        return sortAscending ? Number(a) - Number(b) : Number(b) - Number(a);
    };
    if (sortField && newArr.length > 1) // Sort the array.
    newArr = newArr.sort((a, b)=>cmp(a[sortField], b[sortField]));
    if (dedup.arrayLimit && newArr.length > dedup.arrayLimit) newArr = newArr.splice(0, dedup.arrayLimit);
    return {
        ...fresh,
        [arrayElement]: newArr
    };
}
/**
 * If variable comes from cache value, return specific value from cache entry
 * @template T
 * @param cached - object in cache
 * @param contract
 * @returns value of variable field from cached item
 */ function $0c509505748f8fd4$var$getCacheVariable(cached, dedup) {
    if (cached?.value) {
        const { arrayElement: arrayElement, sortField: sortField } = dedup;
        const entry = [
            ...$0c509505748f8fd4$var$getArray(cached.value, arrayElement)
        ];
        return entry.length > 0 ? +entry[0][sortField] : cached.createdAt;
    }
    return cached.createdAt;
}
/**
 * @returns transformed value from variable key string
 */ function $0c509505748f8fd4$var$getTransformedValue(variableKey, context, appId, cached, contract) {
    switch(variableKey){
        case $lKKKr.StandardVariables.ACP_FD:
            return $0c509505748f8fd4$var$getAcpFulfillableData(context);
        case $lKKKr.StandardVariables.CACHED_TS:
            if (!cached) throw new Error(`Cached data required but not available ${variableKey}`);
            return cached.createdAt;
        case $lKKKr.StandardVariables.DEDUP_SF:
            if (!cached || !contract?.refreshData?.dedup) throw new Error(`Cached data is not available or dedup config is not defined. Both are required ${variableKey}`);
            return $0c509505748f8fd4$var$getCacheVariable(cached, contract.refreshData.dedup);
        case $lKKKr.StandardVariables.APP_ID:
            return appId;
    }
}
/**
 * Computes any GraphQL variables that are required dynamically.
 * @template T
 * @param variables - GraphQL variables payload as defined in the data contract
 * @param context - Core Context
 * @param cached - Cached data (Optional)
 */ function $0c509505748f8fd4$var$transformVariables(variables, context, appId, cached, contract) {
    const transformed = {};
    if (variables) Object.entries(variables).forEach(([key, value])=>{
        if (typeof value === "string" && value.startsWith("${") && value.endsWith("}")) {
            // This value needs to be transformed, remove ${} first
            const variableKey = value.slice(2, value.length - 1);
            transformed[key] = $0c509505748f8fd4$var$getTransformedValue(variableKey, context, appId, cached, contract);
        } else transformed[key] = value;
    });
    return transformed;
}

});
parcelRegister("lKKKr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StandardVariables = module.exports.FRESH_MS = void 0;
/*************************************************************************
 * Copyright 2022 Adobe
 * All Rights Reserved.
 *
 * NOTICE: Adobe permits you to use, modify, and distribute this file in
 * accordance with the terms of the Adobe license agreement accompanying
 * it. If you have received this file from a source other than Adobe,
 * then your use, modification, or distribution of it requires the prior
 * written permission of Adobe.
 **************************************************************************/ /**
 * @packageDocumentation
 * @module network
 */ const $543e16f9c80b4071$var$FRESH_MS = 60000; // One minute.
module.exports.FRESH_MS = $543e16f9c80b4071$var$FRESH_MS;
let $543e16f9c80b4071$var$StandardVariables;
/**
 * Defines the conditions when certain data can be fetched.
 * When conditions are not met, default data will be returned but not cached.
 */ module.exports.StandardVariables = $543e16f9c80b4071$var$StandardVariables;
(function(StandardVariables) {
    StandardVariables["ACP_FD"] = "acpFulfillableData";
    StandardVariables["APP_ID"] = "appId";
    StandardVariables["CACHED_TS"] = "cached.createdAt";
    StandardVariables["DEDUP_SF"] = "dedup.sortField";
})($543e16f9c80b4071$var$StandardVariables || (module.exports.StandardVariables = $543e16f9c80b4071$var$StandardVariables = {}));

});



parcelRegister("cRLuS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.OBJECTIVE_NAMES = module.exports.ROLE_NAMES = void 0;
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ const $a937bde7a1d8d3ec$var$ROLE_NAMES = {
    ADMN: "administration",
    DAAN: "analytics",
    ENG: "engineering",
    GOV: "governance",
    MRKT: "marketing",
    OTH: "other",
    PROD: "product"
};
module.exports.ROLE_NAMES = $a937bde7a1d8d3ec$var$ROLE_NAMES;
const $a937bde7a1d8d3ec$var$OBJECTIVE_NAMES = {
    AUDIENCES: "audiences",
    COMMUNICATE: "communicate",
    COMPLIANCE: "compliance",
    DASHBOARD: "dashboard",
    EXPERIMENTS: "experiments",
    FRICTION: "friction",
    INGESTION: "ingestion",
    INSIGHTS: "insights",
    KPI: "kpis",
    LICENSE: "license",
    OTHER: "other",
    PATTERNS: "patterns",
    POLICIES: "policies",
    PROFILES: "profiles",
    ROADMAP: "roadmap",
    STRATEGIES: "strategies",
    STRUCTURE: "structure",
    TARGETING: "targeting",
    TRACK: "track",
    USERS: "users"
};
module.exports.OBJECTIVE_NAMES = $a937bde7a1d8d3ec$var$OBJECTIVE_NAMES;

});


//# sourceMappingURL=postAuth.c7d26c63.js.map
